import React, { useEffect, useState } from 'react';
import './Moloni.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation } from 'react-router-dom';

const PaymentSuccess = () => {
  const location = useLocation();
  const [isPaymentProcessed, setIsPaymentProcessed] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const domain = "https://strapi-nopcommerce.websitesemconta.com";

  useEffect(() => {
    const getSessionIdFromUrl = () => {
      const params = new URLSearchParams(location.search);
      return params.get('session_id');
    };

    const sendSessionIdToBackend = async (session_id) => {
      try {
        const response = await fetch(`${domain}/api/moloni/payment-success?session_id=${session_id}`, {
          method: 'GET',
        });

        if (response.ok) {
          console.log('Pagamento processado com sucesso!');
          setIsPaymentProcessed(true);
        } else {
          console.error('Erro ao processar o pagamento');
        }
      } catch (error) {
        console.error('Erro na requisição ao backend:', error);
      }
    };

    const session_id = getSessionIdFromUrl();

    if (session_id && !hasFetched && !localStorage.getItem('session_id_processed')) {
      sendSessionIdToBackend(session_id);
      setHasFetched(true);
      localStorage.setItem('session_id_processed', session_id);
    }
  }, [location.search, hasFetched]);

  useEffect(() => {
    if (isPaymentProcessed) {
      const initiateDownload = () => {
        const link = document.createElement('a');
        link.href = `${domain}/api/moloni/download-file`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      initiateDownload();
    }
  }, [isPaymentProcessed]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center p-4 border rounded shadow-sm">
        <div className="mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72"
            height="72"
            fill="currentColor"
            className="bi bi-check-circle-fill text-success"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.97 11.03a.75.75 0 0 0 1.08-.02l3.992-4.99a.75.75 0 1 0-1.174-.96L7.477 9.417 5.383 7.324a.75.75 0 0 0-1.066 1.05l2.657 2.657z" />
          </svg>
        </div>
        <h1 className="h4">Pagamento Realizado com Sucesso!</h1>
        <p className="mb-3">Obrigado pelo seu pagamento. O seu download começará em breve.</p>
        <p>
          Se o download não começar automaticamente,{' '}
          <a href={`${domain}/api/moloni/download-file`} download>
            Clique aqui para baixar o arquivo
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccess;